import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

export default function TOS() {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 py-12 animate-fade-in">
      <div className="mb-10">
        <h1 className="font-rajdhani font-bold text-4xl md:text-5xl uppercase mb-3" data-testid="tos-title">
          Terms of <span className="text-rm-red">Service</span>
        </h1>
        <p className="text-rm-muted text-sm">Last updated: February 2026</p>
        <div className="flex gap-2 mt-4 bg-rm-red/10 border border-rm-red/30 rounded-sm p-3">
          <ShieldAlert size={16} className="text-rm-red shrink-0 mt-0.5" />
          <p className="text-xs text-rm-muted">RobloxMart is not affiliated with Roblox Corporation. We do not process payments. We only connect buyers and sellers.</p>
        </div>
      </div>

      <div className="space-y-8 text-sm">
        {[
          {
            title: "1. Platform Purpose",
            content: `RobloxMart ("we", "the platform") is a connector service that allows users to browse and list Roblox in-game items. RobloxMart does NOT process any payments, hold funds, act as escrow, or guarantee any trades. All transactions occur entirely outside of this platform between buyers and sellers directly.`
          },
          {
            title: "2. Disclaimer & Affiliation",
            content: `RobloxMart is an independent platform and is NOT affiliated with, endorsed by, or connected to Roblox Corporation in any way. "Roblox" and related marks are trademarks of Roblox Corporation.`
          },
          {
            title: "3. Account Requirements",
            content: `You must be at least 13 years old to create an account. You must provide a valid email address and verify it. You are responsible for keeping your account credentials secure. We reserve the right to suspend or ban accounts that violate these terms.`
          },
          {
            title: "4. Seller Responsibilities",
            content: `Sellers are solely responsible for the accuracy of their listings. Sellers must provide accurate item descriptions, prices, and quantities. Sellers must honor deals they enter into with buyers. Creating fake or misleading listings is strictly prohibited and will result in a permanent ban.`
          },
          {
            title: "5. Buyer Responsibilities",
            content: `Buyers are responsible for conducting due diligence before completing any trade. RobloxMart does not guarantee the quality or delivery of any item. We strongly recommend using a trusted middleman (MM) for high-value trades. Always trade at your own risk.`
          },
          {
            title: "6. Contact Reveal System",
            content: `The "Show Seller Contact" feature reveals seller contact information so buyers can complete trades off-platform. This feature is rate-limited to prevent abuse. Misuse of revealed contact information for spam, harassment, or scamming is prohibited.`
          },
          {
            title: "7. Prohibited Conduct",
            content: `The following are strictly prohibited: (a) Scamming or attempting to scam other users; (b) Creating fake listings; (c) Harassment or inappropriate behavior; (d) Creating multiple accounts to evade bans; (e) Using the platform for any illegal activity; (f) Attempting to bypass security measures.`
          },
          {
            title: "8. Reviews & Reports",
            content: `Reviews must be genuine and based on actual trading experience. Fake reviews are prohibited. Proof screenshots must be authentic. False reports made in bad faith may result in account suspension.`
          },
          {
            title: "9. Content Moderation",
            content: `RobloxMart reserves the right to remove any listing, review, or user account at its sole discretion, especially when it violates these terms. We may take action including warnings, temporary suspension, or permanent bans.`
          },
          {
            title: "10. Limitation of Liability",
            content: `RobloxMart is provided "as is" without any warranties. We are not liable for any losses, damages, or disputes arising from trades facilitated through this platform. Use the platform at your own risk. We do not mediate disputes between buyers and sellers.`
          },
          {
            title: "11. Privacy",
            content: `We collect minimal personal data (email, username) necessary to operate the platform. We do not sell your data to third parties. Contact information shared in listings is visible only to logged-in users who reveal it.`
          },
          {
            title: "12. Changes to Terms",
            content: `We reserve the right to update these terms at any time. Continued use of the platform after changes constitutes acceptance of the new terms. Major changes will be announced on the platform.`
          },
          {
            title: "13. Contact",
            content: `For questions about these terms, join our Discord server for support. We do not offer email support at this time.`
          },
        ].map(({ title, content }) => (
          <div key={title} className="bg-rm-card border border-rm-border rounded-sm p-6">
            <h2 className="font-rajdhani font-bold text-lg uppercase mb-3 text-rm-red">{title}</h2>
            <p className="text-rm-muted leading-relaxed">{content}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link to="/" className="btn-outline px-6 py-3 rounded-sm text-sm inline-block">Back to Home</Link>
      </div>
    </div>
  );
}
